import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMan = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "man",
	width: "17px",
	height: "17px",
	viewBox: "0 0 17 17",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "man" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("defs", {}),
		/* @__PURE__ */ _jsx("g", {
			id: "Artboard",
			fill: "currentColor",
			fillRule: "evenodd",
			transform: "translate(-669.000000, -659.000000)",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Page-1",
				transform: "translate(158.000000, 213.000000)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "person",
					transform: "translate(511.000000, 446.000000)",
					children: /* @__PURE__ */ _jsx("path", { d: "M14.3878,12.6954 C14.3878,12.6954 13.1998,12.3284 11.2738,11.6504 C11.2558,11.3154 11.0048,10.8644 10.5608,10.8644 L10.5138,10.8644 L9.9358,10.8644 L10.0278,9.5254 C10.9858,9.0754 11.4128,8.3704 11.5948,7.4304 C11.7318,6.7254 11.8868,4.9294 11.8868,3.9564 C11.8868,2.9954 11.6298,0.5344 8.4258,0.5344 C8.4158,0.5344 8.4018,0.5344 8.3908,0.5344 C8.3738,0.5344 8.3598,0.5344 8.3458,0.5344 C5.4768,0.5344 5.0298,2.9384 5.0298,3.9564 C5.0298,4.5684 5.1958,6.7514 5.3208,7.4304 C5.4748,8.2604 5.8668,9.1704 6.8868,9.5254 L6.9788,10.8644 L6.3998,10.8644 L6.3538,10.8644 C5.9098,10.8644 5.6648,11.3464 5.6398,11.6814 C3.7758,12.3914 2.3088,12.7894 2.3088,12.7894 C0.9138,13.3304 0.4908,13.9754 0.4508,14.6814 L0.4508,15.2294 L0.4508,15.8854 L0.4758,16.0574 C0.4998,16.1494 0.5458,16.2294 0.6018,16.3014 C0.6808,16.4054 0.7878,16.4724 0.9128,16.5074 C0.9598,16.5194 1.0068,16.5334 1.0578,16.5334 L15.8258,16.5334 C15.9978,16.5334 16.1448,16.4594 16.2528,16.3354 C16.4148,16.1844 16.4508,15.8854 16.4508,15.8854 L16.4508,15.2294 L16.4508,14.7334 C16.4508,14.7134 16.4418,14.6464 16.4288,14.6054 C16.2768,14.1144 15.8608,13.3574 14.3878,12.6954" })
				})
			})
		})
	]
});
export default SvgMan;
